// Getränke-Mengenrechner für Feiern: reine Logik. Faustregeln pro Person,
// abhängig von Dauer und Anteil Alkoholtrinker. Konstanten = bewährte
// Event-Richtwerte (Bezug ~6 h Feier).
const REF_STUNDEN = 6;
const BIER_PRO_TRINKER_L = 1.0; // je Bier-Trinker über 6 h
const WEIN_PRO_TRINKER_L = 0.4; // je Wein-Trinker über 6 h
const SEKT_PRO_ALK_L = 0.1; // Empfang/Anstoßen, einmalig (nicht zeit-skaliert)
const WASSER_PRO_GAST_L = 0.5;
const SOFT_PRO_NICHTTRINKER_L = 0.6;
const SOFT_PRO_TRINKER_L = 0.3;

const num = (v) => (Number(v) || 0);
const r1 = (v) => Math.round(v * 10) / 10;
const flaschen = (liter, groesse) => (liter <= 0 ? 0 : Math.ceil(liter / groesse));

export function getraenke({ gaeste, stunden = 5, alkoholAnteil = 70, bierAnteil = 60, puffer = 10 } = {}) {
  const g = Math.max(0, Math.round(num(gaeste)));
  const zeit = num(stunden) / REF_STUNDEN;
  const puff = 1 + num(puffer) / 100;
  const alk = Math.round(g * num(alkoholAnteil) / 100);
  const nicht = g - alk;
  const bierTr = Math.round(alk * num(bierAnteil) / 100);
  const weinTr = alk - bierTr;

  const bierL = bierTr * BIER_PRO_TRINKER_L * zeit * puff;
  const weinL = weinTr * WEIN_PRO_TRINKER_L * zeit * puff;
  const sektL = alk * SEKT_PRO_ALK_L * puff; // einmaliger Empfang
  const wasserL = g * WASSER_PRO_GAST_L * zeit * puff;
  const softL = (nicht * SOFT_PRO_NICHTTRINKER_L + alk * SOFT_PRO_TRINKER_L) * zeit * puff;

  return {
    gaeste: g,
    bier: { liter: r1(bierL), flaschen: flaschen(bierL, 0.5), kisten: flaschen(bierL, 10) },
    wein: { liter: r1(weinL), flaschen: flaschen(weinL, 0.75) },
    sekt: { liter: r1(sektL), flaschen: flaschen(sektL, 0.75) },
    wasser: { liter: r1(wasserL), flaschen: flaschen(wasserL, 1) },
    softdrinks: { liter: r1(softL), flaschen: flaschen(softL, 1) },
    gesamtLiter: r1(bierL + weinL + sektL + wasserL + softL),
  };
}
